import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../Checkbox';
import FieldLabel from '../FieldLabel';

import styles from './styles.scss';

const LabeledCheckbox = ({ label, checked, editMode, allowBlank, onChange, ...props }) => (
  <div className="d-flex">
    <span className={styles.checkboxWrap}>
      <Checkbox checked={checked} onChange={onChange} {...props} />
    </span>
    <FieldLabel label={`${label ? label : ''} ${editMode && !allowBlank ? '*' : ''}`} />
  </div>
);

LabeledCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  editMode: PropTypes.bool,
  allowBlank: PropTypes.bool,
  onChange: PropTypes.func,
};

export default LabeledCheckbox;



// WEBPACK FOOTER //
// src/components/shared/LabeledCheckbox/index.jsx